import { UUID_ROUTE } from './constants';

function trackReferralProfile() {
  const url = new URL(UUID_ROUTE, process.env.REACT_APP_PG_MONOLITH_HOST || window.location.origin);

  url.searchParams.append('referrer', encodeURIComponent(document.referrer));

  return fetch(url.toString(), {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
    },
  });
}

export default trackReferralProfile;
